const { buildTrackQuality } = require('../../utils/trackQuality')

function buildVehicleExportSnapshot(items, options) {
  if (!items.length || items.length > 20) throw new Error('导出须为1—20辆车')
  const vehicles = items.map(item => {
    const status = ['SUCCESS', 'NO_DATA', 'FAILED', 'CANCELED'].includes(item.status) ? item.status : 'CANCELED'
    const quality = buildTrackQuality(status === 'SUCCESS' && item.result ? item.result.points || [] : [], options)
    return { vehicleNo: item.vehicleNo, plateColor: item.plateColor, resultStatus: status, message: item.message || '', points: quality.points.map(point => ({ ...point, speed: point.speed != null && Number.isFinite(Number(point.speed)) && Number(point.speed) >= 0 ? point.speed : null, rawSpeed: point.rawSpeed || (point.speed != null && Number(point.speed) < 0 ? String(point.speed) : null), address: point.address || '未解析' })), parkings: quality.parkings.map(point => ({ ...point, address: point.address || '未解析' })) }
  })
  const snapshot = { startTime: options.startTime, endTime: options.endTime, gapMinutes: options.gapMinutes, parkingMinMinutes: options.parkingMinMinutes, addressMode: options.addressMode, vehicles }
  const count = vehicles.reduce((sum, item) => sum + item.points.length + item.parkings.length, 0)
  if (count > 50000) throw new Error('轨迹和停车记录合计不能超过50000条，不会截断导出')
  if (new Blob([JSON.stringify(snapshot)]).size > 20 * 1024 * 1024) throw new Error('快照不能超过20MiB')
  return snapshot
}

async function resolveSnapshotAddresses(snapshot, resolveAddress, isCanceled, onProgress = () => {}) {
  const rows = snapshot.vehicles.flatMap(vehicle => snapshot.addressMode === 'ALL' ? [...vehicle.points, ...vehicle.parkings] : snapshot.addressMode === 'PARKING' ? vehicle.parkings : [])
  const cache = new Map()
  for (let index = 0; index < rows.length; index++) {
    if (isCanceled()) throw new Error('已取消地址解析')
    const row = rows[index]
    if (!row.address || row.address === '未解析') {
      const key = `${row.longitude},${row.latitude}`
      if (!cache.has(key)) {
        let address = ''
        try { address = await resolveAddress(row.longitude, row.latitude) } catch (error) { address = '' }
        cache.set(key, address || '')
      }
      row.address = cache.get(key) || '未解析'
    }
    onProgress(index + 1, rows.length)
  }
  if (isCanceled()) throw new Error('已取消地址解析')
  let unresolved = 0
  snapshot.vehicles.forEach(vehicle => {
    vehicle.unresolvedAddressCount = [...vehicle.points, ...vehicle.parkings].filter(row => !row.address || ['未解析', '未知位置', '--', '暂无数据'].includes(String(row.address).trim())).length
    unresolved += vehicle.unresolvedAddressCount
  })
  return { unresolved, total: rows.length }
}

module.exports = { buildVehicleExportSnapshot, resolveSnapshotAddresses }
